module.exports = __webpack_public_path__ + "img/HG4102-01.69c32276.jpg";